import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

export const DETAIL_GUTTER = 5;

export const SECTION_TITLE_SX = { fontSize: 14, fontWeight: 600, color: 'text.primary' };

export const SECTION_CAPTION_SX = { fontSize: 11, color: 'text.secondary' };

interface SectionHeaderProps {
  title: string;
  caption?: string;
  actions?: ReactNode;
}

export function SectionHeader({ title, caption, actions }: SectionHeaderProps): ReactNode {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, minWidth: 0 }}>
        <Typography sx={{ ...SECTION_TITLE_SX, whiteSpace: 'nowrap' }}>{title}</Typography>
        {caption === undefined ? null : (
          <Typography sx={{ ...SECTION_CAPTION_SX, whiteSpace: 'nowrap' }}>{caption}</Typography>
        )}
      </Box>
      {actions}
    </Box>
  );
}
